import type { ReactElement } from 'react';
import Select, { type OptionType } from '@atlaskit/select';
import { defineMessages, useIntl } from 'react-intl';
import { Box, xcss } from '@atlaskit/primitives';

const messages = defineMessages({
  siteLabel: {
    id: 'siteSelector.label',
    defaultMessage: 'Use app on',
    description: 'Description for which sites user wants to authorize',
  },
  sitePlaceholder: {
    id: 'siteSelector.sitePlaceholder',
    defaultMessage: 'Choose a site',
    description: 'Placeholder for which sites user wants to authorize',
  },
});

const siteSelectStyles = xcss({
  minWidth: '250px',
});

const dummyOptions: OptionType[] = [
  { label: 'ay11.atlassian.net', value: 'ay11.atlassian.net' },
  { label: 'shipit.atlassian.net', value: 'shipit.atlassian.net' },
  { label: 'trello.atlassian.net', value: 'trello.atlassian.net' },
];

const SiteSelector: React.FC = (): ReactElement => {
  const { formatMessage } = useIntl();

  return (
    <Box xcss={siteSelectStyles}>
      <Select
        options={dummyOptions}
        placeholder={formatMessage(messages.sitePlaceholder)}
      />
    </Box>
  );
};

export default SiteSelector;
